import type { FunctionComponent } from 'react';
import { Box, Inline, xcss } from '@atlaskit/primitives';

import Footer from '../../Footer/Footer';
import LegalDisclaimer from './LegalDisclaimer/LegalDisclaimer';

/**
 * Spacer reserving bottom space so the (fixed) bar never overlaps content.
 * Rendered at the end of the content column.
 */
const spacerStyle = xcss({
  height: 'space.800',
  flexShrink: 0,
});

const stickyBarStyle = xcss({
  position: 'fixed',
  bottom: 'space.0',
  left: 'space.0',
  zIndex: 'navigation',
  width: '100%',
  boxSizing: 'border-box',
  flexShrink: 0,
  borderTopWidth: 'border.width',
  borderTopStyle: 'solid',
  borderTopColor: 'color.border',
  backgroundColor: 'elevation.surface',
  paddingInline: 'space.400',
  paddingBlock: 'space.200',
});

const legalSlotStyle = xcss({
  flex: '1 1 240px',
  minWidth: '0',
});

const actionsSlotStyle = xcss({
  flexShrink: 0,
});

/**
 * Spacer that keeps the last bit of scrollable content clear of the sticky bar.
 * Exported so the layout can place it at the end of the content column.
 */
export const RovoStickyFooterSpacer: FunctionComponent = () => (
  <Box xcss={spacerStyle} aria-hidden="true" />
);

export interface RovoStickyFooterProps {
  /** Forwarded to the underlying `Footer` to disable Accept when required. */
  acceptDisabled?: boolean;
}

const RovoStickyFooter: FunctionComponent<RovoStickyFooterProps> = ({
  acceptDisabled,
}) => (
  <Box xcss={stickyBarStyle}>
    <Inline
      alignBlock="center"
      spread="space-between"
      space="space.400"
      shouldWrap
    >
      <Box xcss={legalSlotStyle}>
        <LegalDisclaimer variant="inline" />
      </Box>
      <Box xcss={actionsSlotStyle}>
        <Footer acceptDisabled={acceptDisabled} embedded reverseOrder />
      </Box>
    </Inline>
  </Box>
);

export default RovoStickyFooter;
